"use client";

import { FilterBar } from "@faire/retailer-visitor-shared/components/Filters/FilterBar";
import { FilterModal } from "@faire/retailer-visitor-shared/components/Filters/FilterModal/FilterModal";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";

interface IProps {
  name: FilterName;
  resultsCount: string;
  isLoading?: boolean;
  className?: string;
  isSticky?: boolean;
  headerSeparator?: boolean;
  PageActions?: React.ReactNode;
  children?: React.ReactNode;
  showUnformattedResultsCount?: boolean;
}

const FilterBase: React.FC<IProps> = ({
  name,
  resultsCount,
  isLoading,
  className,
  isSticky = false,
  headerSeparator = false,
  PageActions,
  children,
  showUnformattedResultsCount = false,
}) => {
  const { isTabletAndBelow } = useViewport();
  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);

  return !isTabletAndBelow ? (
    <StyledFilterBar
      name={name}
      headerSeparator={headerSeparator}
      $isVisible={isSideBarVisible}
      isSticky={isSticky}
      isLoading={isLoading}
      className={className}
      PageActions={PageActions}
      showUnformattedResultsCount={showUnformattedResultsCount}
    >
      {children}
    </StyledFilterBar>
  ) : (
    <FilterModal name={name} resultsCount={resultsCount} isLoading={isLoading}>
      {children}
    </FilterModal>
  );
};

export const Filter = observer(FilterBase);

const StyledFilterBar = styled(FilterBar)<{ $isVisible: boolean }>`
  &&& {
    ${responsiveMediaQueries.tabletAndBelow} {
      display: none;
    }
    display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
    height: 100%;
    width: 100%;
    max-width: 228px;
  }
`;
